/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Load_TitleInputs */

const en_gb2_error_load_title = /** @type {(inputs: Error_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load this page`)
};

const fr_error_load_title = /** @type {(inputs: Error_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger cette page`)
};

/**
* | output |
* | --- |
* | "Couldn't load this page" |
*
* @param {Error_Load_TitleInputs} inputs
* @param {{ locale?: "en-GB" | "fr" }} options
* @returns {LocalizedString}
*/
export const error_load_title = /** @type {((inputs?: Error_Load_TitleInputs, options?: { locale?: "en-GB" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Load_TitleInputs, { locale?: "en-GB" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_load_title(inputs)
	return en_gb2_error_load_title(inputs)
});